import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button/button';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, generatePath } from 'react-router-dom';
import { appRoutes } from 'src/routes/routes.types';

interface BrandOnboardingRequiredDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  brandId?: string;
}

export const BrandOnboardingRequiredDialog: React.FC<BrandOnboardingRequiredDialogProps> = ({
  open,
  onOpenChange,
  brandId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSetupBrand = () => {
    if (brandId) {
      // Navigate to onboarding with brandId to pre-fill existing data
      navigate({
        pathname: appRoutes.createBrand,
        search: `?brandId=${brandId}`,
      });
    } else {
      // Navigate to create brand without pre-fill (new brand)
      navigate(appRoutes.createBrand);
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw-max-w-lg">
        <DialogHeader className="tw-flex tw-flex-row tw-items-start tw-gap-4 tw-space-y-0">
          <div className="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-brand-100">
            <Sparkles className="tw-h-6 tw-w-6 tw-text-brand-500" />
          </div>
          <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-2">
            <DialogTitle className="tw-text-left tw-text-xl tw-font-bold">
              {t('Unlock ben', { defaultValue: 'Unlock ben' })}
            </DialogTitle>
            <DialogDescription className="tw-text-left tw-leading-relaxed">
              <div className="tw-space-y-2">
                <p>
                  {t('Answer a few quick questions to get:', {
                    defaultValue: 'Answer a few quick questions to get:',
                  })}
                </p>
                <ul className="tw-list-none tw-space-y-1 tw-pl-0">
                  <li className="tw-flex tw-items-start tw-gap-2">
                    <span>•</span>
                    <span>
                      {t('Your content strategy', { defaultValue: 'Your content strategy' })}
                    </span>
                  </li>
                  <li className="tw-flex tw-items-start tw-gap-2">
                    <span>•</span>
                    <span>{t('A custom plan', { defaultValue: 'A custom plan' })}</span>
                  </li>
                  <li className="tw-flex tw-items-start tw-gap-2">
                    <span>•</span>
                    <span>
                      {t('Scripts that sound like you', {
                        defaultValue: 'Scripts that sound like you',
                      })}
                    </span>
                  </li>
                </ul>
              </div>
            </DialogDescription>
          </div>
        </DialogHeader>
        <DialogFooter className="tw-flex tw-flex-row tw-gap-2 sm:tw-flex-row">
          <Button onClick={() => onOpenChange(false)} variant="outline" className="tw-flex-1">
            {t('Maybe Later', { defaultValue: 'Maybe Later' })}
          </Button>
          <Button onClick={handleSetupBrand} variant="brand" className="tw-flex-1">
            {t("Let's go", { defaultValue: "Let's go" })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
